<template>
  <div
    class="pa-md-6 creator-text-box w-full"
    :class="{ 'creator-text-box--whatsapp': isWhatsAppStatus }"
  >
    <v-tooltip
      v-if="content"
      location="top"
    >
      <template v-slot:activator="{ props }">
        <v-icon
          class="edit"
          data-testid="content-creator-edit-text-btn"
          v-bind="props"
          @click="handleClick"
        >
          mdi-pencil-outline
        </v-icon>
      </template>
      <span>{{ $t('buttons.content-creator.edit') }}</span>
    </v-tooltip>

    <!-- eslint-disable vue/no-v-html -->
    <div
      ref="measuringDiv"
      :style="{ width: currentWidth - 70 + 'px' }"
      class="creator-text-box-content pointer"
      :class="{ 'creator-text-box-content--whatsapp': isWhatsAppStatus }"
      @click.stop="parsedContent ? handleClick : null"
    >
      <div
        v-if="parsedContent"
        v-html="parsedContent"
      />
      <div
        v-if="!parsedContent && !parsingContent && !isLoading"
        class="d-flex justify-center align-center creator-text-box-content"
      >
        <v-btn @click.stop="generateContent">
          {{ $t('buttons.content-creator.generate-content') }}
        </v-btn>
      </div>
    </div>

    <div
      v-if="isLoading"
      class="loader"
    >
      <ProgressCircularTimed
        :duration="12000"
        :completed="!isLoading"
      />
    </div>
    <!-- eslint-enable vue/no-v-html -->
  </div>
</template>

<script>
import DOMPurify from 'dompurify'
import { marked } from 'marked'

import ProgressCircularTimed from '@/components/ProgressCircularTimed'

import KindType from '../enums/KindType'

export default {
  components: {
    ProgressCircularTimed,
  },
  inject: {
    generateContent: { default: () => () => {} },
    textKind: { default: null },
  },
  props: {
    // could be markdown
    content: {
      type: String,
      default: '',
    },
    // indicates if the content is markdown
    isMarkdown: {
      type: Boolean,
      default: false,
    },
    currentWidth: {
      type: Number,
      default: 250,
    },
    recalculateHeight: {
      type: Number,
      default: null,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      parsedContent: '',
      parsingContent: false,
    }
  },

  computed: {
    isWhatsAppStatus() {
      return (this.textKind?.value || this.textKind) === KindType.whatsappStatus
    },
  },

  watch: {
    recalculateHeight() {
      this.calculateHeight()
    },

    async content() {
      await this.parseContent()
      this.$nextTick(() => {
        this.calculateHeight()
      })
    },
  },

  async mounted() {
    await this.parseContent()
    this.$nextTick(() => {
      this.calculateHeight()
    })
  },

  methods: {
    async parseContent() {
      this.parsingContent = true
      if (this.isMarkdown) {
        const parsed = await marked.parse(this.content)
        // Currently we just sanitize. We could think about allowing only certain tags.
        this.parsedContent = DOMPurify.sanitize(parsed)
      } else {
        this.parsedContent = this.content
      }
      this.parsingContent = false
    },

    calculateHeight() {
      if (this.$refs.measuringDiv) {
        this.$emit('currentHeight', this.$refs.measuringDiv.offsetHeight)
      }
    },

    handleClick() {
      this.$emit('handleClick')
    },
  },
  emits: ['currentHeight', 'handleClick'],
}
</script>

<style scoped>
.creator-text-box {
  overflow: auto;
  scrollbar-width: thin;
  height: 100%;
}

@media (max-width: 960px) {
  .creator-text-box {
    padding: 10px 20px;
  }

  .creator-text-box-content {
    font-size: 12px;
    padding: 10px;
  }
}

.creator-text-box-content {
  position: relative;
  white-space: pre-wrap;
  font-size: 14px;
  min-height: 300px;
}

.creator-text-box--whatsapp {
  padding-top: 12px;
  padding-bottom: 12px;
}

.creator-text-box-content--whatsapp {
  min-height: 140px;
}

.edit {
  cursor: pointer;
  position: absolute;
  top: 10px;
  right: 10px;
}

.pointer {
  cursor: pointer;
}

.loader {
  position: absolute;
  top: 5px;
  left: 5px;
  right: 5px;
  bottom: 5px;
  width: calc(100% - 10px);
  height: calc(100% - 10px);
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: none;
  z-index: 1000;
}
</style>
